<template>
    <router-link :to="to">
        <img src="../assets/icons/account.svg" :alt="title" />
        <span v-if="show">{{title}}</span>
    </router-link>
</template>
<script>
export default {
    name:'AccountIcon',
    props:{
        title: String,
        to: {
            type: [String, Object]
        },
        show:{
            type: Boolean,
            default: true
        }
    }
}
</script>
<style lang="scss" scoped>
a{
    position: relative;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    margin: 0 8px;
    justify-content: center;
    text-align: center;
    height: 58px;
    color: #000;
    font-size: 14px;
    line-height: 17px;
    img{
        height: 21px;
        margin-bottom: 7px;
    }
    span{
        display: inline-block;
        
        border-radius: 12px;
        padding: 0 7px;
    }
}
</style>